module.exports = __webpack_public_path__ + "img/address-foreign-tablet-sm-2.cdbed3e5.svg";